var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_70",
    "data-name": "Group 70",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#11989a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-f",
    "data-name": "Icon awesome-facebook-f",
    d: "M10.829,10.362l.512-3.334h-3.2V4.865a1.667,1.667,0,0,1,1.88-1.8h1.454V.225A17.734,17.734,0,0,0,8.894,0C6.26,0,4.538,1.6,4.538,4.487V7.028H1.609v3.334H4.538v8.059h3.6V10.362Z",
    transform: "translate(9.556 7.177)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup70);
export default __webpack_public_path__ + "static/media/Group 70.22542de73bb69027c0418e5d29fdb857.svg";
export { ForwardRef as ReactComponent };